export default {
  title: 'Новый чат',
  form: {
    to: {
      label: 'Кому',
      placeholder: 'Введите номер телефона',
    },
    from: {
      label: 'От',
      placeholder: 'Выберите имя отправителя',
    },
    message: {
      label: 'Сообщение',
      placeholder: 'Введите сообщение...',
    },
    buttons: {
      close: 'Закрыть',
      create: 'Создать',
    },
  },
}
